import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TypeIntervention } from 'src/api/models';

@Component({
  selector: 'app-intervention-type',
  templateUrl: './intervention-type.component.html',
  styleUrls: ['./intervention-type.component.css']
})
export class InterventionTypeComponent implements OnInit {

  @Input('id') public id: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetInterventionType(t: TypeIntervention) {
    if (t === undefined) {
      return '';
    } else {
      return this.translateService.instant('Entretien.Interventions.Types.' + TypeIntervention[t]);
    }
  } 
}
